import StoryblokComponent from "@/lib/storyblok/storyblokSetup/StoryblokComponent/StoryblokComponent";
import { TextBannerStoryblok } from "@/types/blok-types";
import { SbBlokData, storyblokEditable } from "@storyblok/js";
import clsx from "clsx";
import { render } from "storyblok-rich-text-react-renderer";
import styles from "./index.module.css";

const TextBanner = ({
  blok,
  preview
}: {
  blok: TextBannerStoryblok;
  preview?: boolean;
}) => {
  const blokMedia = blok?.media?.[0];

  return (
    <div
      className={clsx(
        styles.wrapper,
        blok?.alignment === "right" && styles.right
      )}
      data-layout="blok"
      {...storyblokEditable(blok as unknown as SbBlokData)}
    >
      <div className={styles.group}>
        {blokMedia && (
          <div className={styles.media}>
            <div className={styles.innermedia}>
              <StoryblokComponent blok={blokMedia} preview={preview} />
            </div>
          </div>
        )}
        <div className={styles.text}>
          <div className={styles.innertext}>
            <div className={styles.titleWrap}>
              <h2 className={styles.title}>{blok?.title}</h2>
            </div>
            <div className={styles.textWrap}>
              <div className={styles.richtext}>{render(blok?.text)}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextBanner;
